import Debug from 'debug';
import { DialogName } from '../services/DialogService';
import { EventHandler } from '../components/Dialog';
import { modalManager } from '../services/ModalManager';
import { Modal } from '../models/Modal';
import { AdditionalDialogData } from '../abstractions/Transcript';

const debug = Debug('o365:wait');

export async function wait(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Opens an error dialog and waits for an action click/close event.
 */
export async function waitForErrorModal(
  name: DialogName,
  onClick: EventHandler,
  dialogOptions: Office.DialogOptions = { displayInIframe: true, width: 25, height: 40 },
) {
  return new Promise((resolve) => {
    function closeHandler() {
      debug('waitForErrorModal() close detected');
      resolve(false);
    }

    modalManager
      .openError(
        name,
        {
          async onClick(this: Modal) {
            debug('waitForErrorModal() received action click');
            this.removeListener('closed', closeHandler);
            await onClick();
            resolve(true);
          },
        },
        null,
        dialogOptions,
      )
      .then((modal) => {
        debug('waitForErrorModal() received modal');
        modal.addListener('closed', closeHandler);
      });
  });
}

/**
 * Opens an error dialog and waits for an action click/close/data ready event.
 */
export async function waitForTranscriptModal(
  name: DialogName,
  onClick: EventHandler,
  additionalData: AdditionalDialogData,
): Promise<boolean> {
  return new Promise((resolve) => {
    // User clicks the 'Cancel Send' button
    async function onCancelHandler(this: Modal) {
      debug('waitForTranscriptModal() received action click');
      this.removeListener('closed', onCloseHandler);
      await onClick();
      resolve(false);
    }

    // User closes the modal
    async function onCloseHandler(this: Modal) {
      debug('waitForTranscriptModal() close detected');
      resolve(false);
    }

    // Transcript status data is clear, close the modal and return true
    async function onDataReady(this: Modal) {
      debug('waitForTranscriptModal() received data ready');
      resolve(true);
    }
    const windowHeight = window.outerHeight;
    const height = windowHeight > 450 ? 45 : 40;
    const dialogOptions = { displayInIframe: true, width: 25, height };
    modalManager
      .openError(
        name,
        { onClick: onCancelHandler, onClose: onCloseHandler, onReady: onDataReady },
        additionalData,
        dialogOptions,
      )
      .then((modal) => {
        debug('waitForTranscriptModal() received modal');
        modal.addListener('closed', onCloseHandler);
      });
  });
}
